import { atomWithStorage } from 'jotai/utils';

import { DEFAULT_LOC_ENV, LocalizationEnv } from '../constants';
import deriveDefaultLocaleForFrontend from './deriveDefaultLocaleForFrontend';

export const atomLocale = atomWithStorage(
  'locale',
  deriveDefaultLocaleForFrontend(null), // Individual apps should override this with their own default locale
  /*= storage */ undefined, // default is localstorage
  { getOnInit: true }
);

export const atomLocalizationEnv = atomWithStorage<LocalizationEnv>(
  'localizationEnv',
  DEFAULT_LOC_ENV,
  /*= storage */ undefined, // default is localstorage
  { getOnInit: true }
);
